<template lang="pug">
v-app
  v-dialog.br-10(v-model="dialog.pedido", v-if="pedido && dialog.pedido", scrollable, max-width="550")
    v-card.br-10(flat)
      v-card-title(v-if="pedido.id").title Pedido {{ pedido.id }}
      v-card-text
        ticketPadrao(v-if="$root.layoutImpressaoNormalSelecionado", :pedido="pedido", color="white", :showContact="false")
        ticketNovo(v-if="!$root.layoutImpressaoNormalSelecionado", :pedido="pedido", color="white", :showContact="false")
      v-card-actions
        v-spacer
        v-btn(type="button", :disabled="loading", flat, color="gray darken-1", @click.native="dialog.pedido = false; pedido = null;") Fechar
        v-btn(type="button", :loading="loading", color="primary", @click="printPedido(pedido)", v-if="pedido.status !== 3").hidden-sm-and-down.white--text Imprimir

  v-container(grid-list-xl, fluid)
    v-layout(row, wrap)
      v-flex(lg12)
        v-card.px-3.br-10.cardPadrao
          v-layout(row, wrap)
            v-flex.md3.xs12
            v-flex.md10.xs12
              v-text-field.Poppins.icon-green.inputDefault(
                label="Buscar pedidos por código ou nome do cliente",
                color="primary",
                height="50px",
                v-model="search",
                clearable,
                outline,
                :hide-details="true"
                prepend-inner-icon="search"
              )

            v-spacer
            v-flex.md2.xs12
              v-menu.xs12(offset-y, :close-on-content-click="false", max-width="400px")
                template.xs12(v-slot:activator="{ on, attrs }")
                  v-btn.br-10.botaoFiltro.ma-0(v-bind="attrs", v-on="on", color="primary", depressed)
                    i.fa.fa-filter.pr-2
                    .Poppins Filtros
                v-card.pt-2
                  v-list.Poppins
                    v-list-tile
                      v-flex(md12, xs12, pa-0, justify-center, d-flex, style="flex-wrap: wrap; align-items: center;")
                        v-btn.ma-0.xs12.br-5(class="botaoItemFiltro", height="33px", @click="setData(dataRangeFormated, 0, 0); setarAtividade('Mês Atual')", depressed)
                          span.Poppins Mês Atual
                    v-list-tile.pb-3
                      v-flex(md12, xs12, pa-0, justify-center, d-flex, style="flex-wrap: wrap; align-items: center;")
                        v-btn.ma-0.xs12.br-5(class="botaoItemFiltro", height="33px", @click="setData(dataRangeFormated, -1, -1); setarAtividade('Mês Anterior')", depressed)
                          span.Poppins Mês anterior
                    v-list-tile.pb-3
                      v-menu.pr-1(offset-y, v-model="data_inicio", lazy, transition="scale-transition", style="max-width: 50%")
                        v-text-field.Poppins.inputDefault(type="date", color="gray", slot="activator", v-model="dataRangeFormated.dataInicio", label="Data Inicial", :hide-details="true", outline, max-width="210px", min-width="210px", @change="validarDatas")
                      v-spacer
                      v-menu.pl-1(offset-y, v-model="data_fim", lazy, transition="scale-transition", style="max-width: 50%")
                        v-text-field.Poppins.inputDefault(type="date", color="gray", slot="activator", v-model="dataRangeFormated.dataFim", label="Data Final", :hide-details="true", outline, @change="validarDatas")
                    v-list-tile.pb-3(v-if="datasInvalidas")
                      span.alertDatas As datas extrapolam o tamanho do mês selecionado.
                    v-list-tile.pb-3
                      v-flex.pl-0.pr-0.areaAddCategoria
                        v-btn.ma-0.Poppins(
                          class="botaoAdicionarCategoria",
                          color="primary",
                          @click="getPedidos(); setarAtividade(null, 3);",
                          :disabled="datasInvalidas || loading"
                          depressed
                        ) Aplicar
    indicadoresMarketplace(v-if="list.length && (!estabelecimentoSelecionado || estabelecimentoSelecionado.cardapio_digital == 0) && !allCardapioDigital", :indicadores="indicadores", @info-total-bruto="openDiagloInfoTotalBruto", @info-total-liquido="openDiagloInfoTotalLiquido", @info-incentivos="openDiagloInfoIncentivos", @info-cancelados="openDiagloInfoCancelados")
    indicadoresCardapioDigital(v-if="list.length && (estabelecimentoSelecionado && estabelecimentoSelecionado.cardapio_digital == 1) || allCardapioDigital", :indicadores="indicadores", @info-total-bruto="openDiagloInfoTotalBruto", @info-cancelados="openDiagloInfoCancelados")

    v-layout(row, wrap)
      v-flex(lg12)
        v-card.pa-3.br-10.cardPadrao
          v-layout(row, wrap)
            v-flex.labelFiltro.font-weight-medium
              span.Poppins {{ 'Filtro aplicado: ' + (filtroAplicado ? filtroAplicado : ('Dia Atual ' + $dayjs().format('DD/MM/YYYY')))}}
              v-btn(v-if="filtroAplicado != null", icon, @click="limparFiltros()")
                i.fa.fa-times
            v-spacer
            v-flex.md2.xs12.pa-0.pl-2.pr-2.justify-center.d-flex(style="flex-wrap:wrap;align-items: center;")
              v-btn.mt-2.xs6.pl-8.pr-8.br-5(
                height="33px",
                class="botaoExportar",
                @click="exportarCSV"
                depressed
              )
                span.Poppins Exportar
          v-divider.mt-1
          v-card-text.pa-0.mt-2
            v-data-table.elevation-1(:headers='headers', :items='list', :rows-per-page-items="rowPerPageConfig", :loading="loading")
              template(slot='items', slot-scope='props')
                tr(style="cursor: pointer;", @click="openDialogPedido(props.item)")
                  td(style="width: 30%;").text-xs-left
                    div.pt-2.pb-2
                      span.font-weight-bold Código: {{ props.item.id }}
                      br
                      span {{ $root.showIdentify(props.item) ? props.item.usuario_nome : '--' }}
                      br
                      span(v-if="!filter.estabelecimento_id").pt-1 {{ props.item.estabelecimento_nome }}
                        br
                        small {{ props.item.localidade_nome + ' - ' + props.item.estado_nome }}
                  td.text-xs-left {{ props.item.endereco_id == -1 ? 'Retirada' : 'Entrega' }}
                  td.text-xs-left
                    span(v-if="props.item.endereco_id == -1") --
                    span(v-else) {{ props.item.taxa_entrega | currency }}
                  td.text-xs-left
                    div
                      v-tooltip(top v-model="props.item.tooltipVisible", v-if="props.item.incentivo")
                        template(v-slot:activator="{ on, attrs }")
                          v-icon(v-bind="attrs" v-on="on"
                              style="font-size:18px"
                              class="pa-0 clicable fa fa-ticket"
                              @click="props.item.tooltipVisible = !props.item.tooltipVisible")
                        span.tooltip-message
                          | Incentivos do Bigou: {{ props.item.incentivo | currency }}
                      span.font-weight-regular {{ props.item.total_liquido | currency }}
                  td.text-xs-left
                    span.font-weight-bold {{ props.item.total_bruto | currency }}
                  td.text-xs-left {{ $dayjs(props.item.data).format('DD/MM/YYYY HH:mm') }}
                  td.text-xs-left
                    v-chip.ma-0(small, :class="['lb-success', 'lb-warning', 'lb-primary', 'lb-danger', 'gray'][props.item.concluido &&  props.item.status != 3 ? 4 : props.item.status]", style="font-size:9px").white--text.font-weight-bold {{ props.item.concluido &&  props.item.status != 3 ? 4 : props.item.status | statusPedido }}
                  td.text-xs-left(v-if="$root.showOrigemPedido()")
                    BadgeOrigem(:cardapio_digital="props.item.cardapio_digital ? true : false")
                  td.text-xs-left
                    v-icon(v-if="!props.item.status_integracao", color="#CCC").fa.fa-ban
                    v-icon(v-if="props.item.status_integracao == 2", color="lb-warning").fa.fa-exclamation-triangle
                    v-icon(v-if="props.item.status_integracao == 1", color="lb-success").fa.fa-check-circle

    dialogInfoTotalBruto(ref="dialogInfoTotalBruto")
    dialogInfoIncentivos(ref="dialogInfoIncentivos")
    dialogInfoCancelados(ref="dialogInfoCancelados")

  </template>

  <script>
  import _ from "lodash";
  import ticketPadrao from '@/components/TicketPadrao';
  import ticketNovo from '@/components/TicketNovo';
  import dialogInfoTotalBruto from '@/pages/relatorio/DialogInfoTotalBruto';
  import dialogInfoIncentivos from '@/pages/relatorio/DialogInfoIncentivos';
  import dialogInfoCancelados from '@/pages/relatorio/DialogInfoCancelados';
  import indicadoresMarketplace from '@/pages/relatorio/IndicadoresMarketplace';
  import indicadoresCardapioDigital from '@/pages/relatorio/IndicadoresCardapioDigital';
  import BadgeOrigem from "@/components/BadgeOrigem";

  import { ExportToCsv } from 'export-to-csv';

  export default {
    components: {
      ticketPadrao,
      ticketNovo,
      dialogInfoTotalBruto,
      dialogInfoIncentivos,
      dialogInfoCancelados,
      indicadoresMarketplace,
      indicadoresCardapioDigital,
      BadgeOrigem
    },
    data() {
      return {
        pedido_id: null,
        data_inicio: false,
        data_fim: false,
        dataRange: {
          data_inicio: this.$dayjs().startOf("day").format("YYYY-MM-DD"),
          data_fim: this.$dayjs().endOf("day").format("YYYY-MM-DD"),
        },
        dataRangeFormated: {
          dataInicio: this.$dayjs().startOf("day").format("YYYY-MM-DD"),
          dataFim: this.$dayjs().endOf("day").format("YYYY-MM-DD"),
        },
        pedidos: [],
        loading: false,
        filtroAplicado: null,
        filter: {
          search: "",
          estabelecimento_id: null,
        },
        search: '',
        indicadores: {},
        rowPerPageConfig: [25, 50, 75, 100, { text: 'Todos', 'value': -1 }],
        dialog: {
          pedido: false,
          info: false,
        },
        info: null,
        pedido: null,
        expanded: false,
        datasInvalidas: false
      };
    },
    computed: {
      legendaIncentivos() {
        const qtdDesconto = this.indicadores.quantidade_desconto;
        const qtdReembolso = this.indicadores.quantidade_reembolso;

        const parts = [];

        if (qtdDesconto) {
          parts.push(`${this.$options.filters.number(qtdDesconto)} cupons do Bigou`);
        }

        if (qtdReembolso) {
          parts.push(`${this.$options.filters.number(qtdReembolso)} subsídios`);
        }

        return parts.join(' + ');
      },
      dataInicio() {
        return this.dataRange.data_inicio ? this.$dayjs(this.dataRange.data_inicio).format("DD/MM/YYYY") : "";
      },
      dataFim() {
        return this.dataRange.data_fim ? this.$dayjs(this.dataRange.data_fim).format("DD/MM/YYYY") : "";
      },
      list() {
        return (this.filter.search && this.filter.search !== '') ? _.filter(this.pedidos, pedido => {
          const matchSearch = (this.filter.search && this.filter.search !== '') ?
            ((pedido.usuario_nome.toLowerCase().indexOf(this.filter.search.toLowerCase()) > -1 && pedido.status != 3) || (pedido.id.toString().toLowerCase().indexOf(this.filter.search.toLowerCase()) > -1))
            : true;
            return matchSearch;
        }) : this.pedidos;
      },
      estabelecimentoSelecionado(){
        return this.$root.estabelecimentoSelecionado;
      },
      allCardapioDigital(){
        return this.$root.estabelecimentos.length == _.filter(this.$root.estabelecimentos, {cardapio_digital: 1}).length
      },
      headers () {

        const headers = [
          { text: "Pedido", value: "id"},
          { text: "Entrega/Retirada", value: "desconto" },
          { text: "Taxa de Entrega", value: "taxa_entrega" },
          { text: "Valor Líquido", value: "total_liquido" },
          { text: "Valor Bruto", value: "total_bruto" },
          { text: "Data", value: "data" },
          { text: "Status", value: "status" }
        ];

        if(this.$root.showOrigemPedido()){
          headers.push({ text: "Origem", value: "cardapio_digital" });
        }

        headers.push({ text: "Integração", value: "status_integracao" });

        return headers;
      },
    },
    watch: {
      list(list) {
        this.indicadores = this.createIndicadores(list);
      },
      search: _.debounce(function (val) {
        this.filter.search = val;
      }, 500),
      'dataRangeFormated.dataInicio': 'validarDatas',
      'dataRangeFormated.dataFim': 'validarDatas'
    },
    created() {
      window.getApp.$on("CHANGE_ESTABELECIMENTO", this.onChangeEstabelecimento);
    },
    beforeDestroy() {
      window.getApp.$off("CHANGE_ESTABELECIMENTO", this.onChangeEstabelecimento);
    },
    mounted(){
      this.onChangeEstabelecimento()
    },
    methods: {
      onChangeEstabelecimento(){
        console.log('CHANGE_ESTABELECIMENTO PEDIDOS', this.estabelecimentoSelecionado)
        this.getPedidos();
      },
      formatarData(data){
        return this.$dayjs(data).format("DD/MM/YYYY");
      },
      limparFiltros(){
        this.filtroAplicado = null;
        this.dataRangeFormated.dataInicio = this.$dayjs().startOf("day").format("YYYY-MM-DD");
        this.dataRangeFormated.dataFim = this.$dayjs().endOf("day").format("YYYY-MM-DD");
        this.getPedidos();
      },
      gerenciarFiltro(){
        this.dataRangeFormated.dataInicio = this.$dayjs(this.dataRange.data_inicio).format("YYYY-MM-DD");
        this.dataRangeFormated.dataFim = this.$dayjs(this.dataRange.data_fim).format("YYYY-MM-DD");
      },
      setarAtividade(atividade, tipo){
        let label
        if(tipo == 3){
          label = this.formatarData(this.dataRangeFormated.dataInicio) + ' até ' + this.formatarData(this.dataRangeFormated.dataFim);
          this.filtroAplicado = label;
        }else{
          label = atividade;
          this.filtroAplicado = atividade;
        }
        this.$firebase.logEvent('report_filter_applied', {
          filter_label: label,
          establishment_id: this.estabelecimentoSelecionado ? this.estabelecimentoSelecionado.id : null,
        })
      },
      openDiagloInfoTotalBruto(){
        this.$refs.dialogInfoTotalBruto.open(this.indicadores, true);
      },
      openDiagloInfoTotalLiquido(){
        this.$refs.dialogInfoTotalBruto.open(this.indicadores, false);
      },
      openDiagloInfoIncentivos(){
        this.$refs.dialogInfoIncentivos.open(this.indicadores);
      },
      openDiagloInfoCancelados(){
        this.$refs.dialogInfoCancelados.open(this.indicadores);
      },
      async openDialogPedido(p) {
        try {
          this.dialog.pedido = true;
          this.$firebase.logEvent('report_order_viewed', {
            order_id: p.id,
            establishment_id: this.estabelecimentoSelecionado ? this.estabelecimentoSelecionado.id : null,
          })
          const pedido = await this.$root.getPedido(p.id);
          this.pedido = _.cloneDeep(pedido);
        } catch (error) {
          let err = error.response && error.response.data ? error.response.data.error : "Ocorreu um erro ao carregar o pedido. Tente novamente!";
          window.getApp.$emit("APP_ALERT", { color: "red", text: err });
        }
      },
      setData(dataRange, mesesInicio, mesesFinal) {
        this.dataRangeFormated.dataInicio = this.$dayjs().add(mesesInicio, "month").startOf("month").format("YYYY-MM-DD");
        this.dataRangeFormated.dataFim = this.$dayjs().add(mesesFinal, "month").endOf("month").format("YYYY-MM-DD");
        this.getPedidos();
      },
      async getPedidos() {
        try {
          this.loading = true;
          const response = await this.$axios.get("/pedido", {
            params: {
              estabelecimento_id : this.estabelecimentoSelecionado ? this.estabelecimentoSelecionado.id : null,
              data_inicio: this.dataRangeFormated.dataInicio ? this.$dayjs(this.dataRangeFormated.dataInicio).format("YYYY-MM-DD 00:00:00") : null,
              data_fim: this.dataRangeFormated.dataFim ? this.$dayjs(this.dataRangeFormated.dataFim).format("YYYY-MM-DD 23:59:59") : null,
              columns: "estabelecimento,localidade,estado,usuario,forma_pagamento",
              fields: "none",
              orderDesc: "data",
              statusList: "1,2,3",
            },
          });
          response.data.forEach(pedido => {
            pedido.incentivo = pedido.estabelecimento_cupom == 1 ? pedido.reembolso_promocao : pedido.reembolso_promocao + pedido.desconto;
            pedido.desconto_loja = pedido.estabelecimento_cupom == 1 ? pedido.desconto : 0;
            pedido.total_liquido = pedido.total;
            pedido.total_bruto = pedido.total + pedido.incentivo;
            pedido.taxa_entrega = pedido.endereco_id == -1 ? 0 : (Number(pedido.taxa_entrega) || 0);
          })
          this.loading = false;
          this.pedidos = response.data;
        } catch (error) {
          let err = error.response && error.response.data ? error.response.data.error : "Ocorreu um erro ao buscar os pedidos. Atualize a página!";
          window.getApp.$emit("APP_ALERT", { color: "red", text: err });
          this.loading = false;
        }
      },
      createIndicadores(list) {
        const indicadores = {};
        const pedidosValidos = _.filter(list, o => o.status === 1 || o.status === 2);
        const pedidosCancelados = _.filter(list, o => o.status === 3);
        const pedidosCanceladosNaoExpirados = _.filter(pedidosCancelados, o => o.tipo_cancelamento !== 1);
        const pedidosCanceladosExpirados = _.filter(pedidosCancelados, o => o.tipo_cancelamento === 1);

        const calcValorBruto = (o)=>{
          const comissaoReembolso = this.$dayjs(o.data).isAfter(this.$dayjs('2024-03-31 23:59:59'));
          const reembolso = comissaoReembolso ? o.reembolso_promocao : 0;
          return o.estabelecimento_cupom == 1 ? o.total + reembolso : (o.total + o.desconto + reembolso)
        }

        indicadores.total_bruto = _.sumBy(pedidosValidos, calcValorBruto);

        indicadores.quantidade_aceitos = pedidosValidos.length;
        indicadores.quantidade_pedidos = pedidosValidos.length;
        indicadores.quantidade_cancelados = pedidosCancelados.length;
        indicadores.quantidade_cancelados_nao_expirados = pedidosCanceladosNaoExpirados.length;
        indicadores.quantidade_cancelados_expirados = pedidosCanceladosExpirados.length;

        indicadores.quantidade_desconto = _.countBy(pedidosValidos, o => o.estabelecimento_cupom == 0 && o.cupom_desconto_id != null).true;
        indicadores.quantidade_reembolso = _.countBy(pedidosValidos, o => o.reembolso_promocao > 0).true;
        indicadores.quantidade_desconto_estabelecimento = _.countBy(pedidosValidos, o => o.estabelecimento_cupom == 1 && o.cupom_desconto_id != null).true;

        indicadores.desconto = _.sumBy(pedidosValidos, o => o.estabelecimento_cupom ? 0 : o.desconto);
        indicadores.desconto_pgt_online = _.sumBy(pedidosValidos, o => o.forma_pagamento_id == -1 ? (o.estabelecimento_cupom ? 0 : o.desconto) : 0);
        indicadores.desconto_pgt_dinheiro = _.sumBy(pedidosValidos, o => o.forma_pagamento_id == 1 ? (o.estabelecimento_cupom ? 0 : o.desconto) : 0);
        indicadores.desconto_pgt_maquininha = _.sumBy(pedidosValidos, o => o.forma_pagamento_id > 1 ? (o.estabelecimento_cupom ? 0 : o.desconto) : 0);
        indicadores.desconto_novos = _.sumBy(pedidosValidos, o => o.primeiro || o.primeiro_estabelecimento ? (o.estabelecimento_cupom ? 0 : o.desconto) : 0);

        indicadores.reembolso = _.sumBy(pedidosValidos, o => o.reembolso_promocao);
        indicadores.reembolso_pgt_online = _.sumBy(pedidosValidos, o => o.forma_pagamento_id == -1 ? o.reembolso_promocao : 0);
        indicadores.reembolso_pgt_dinheiro = _.sumBy(pedidosValidos, o => o.forma_pagamento_id == 1 ? o.reembolso_promocao : 0);
        indicadores.reembolso_pgt_maquininha = _.sumBy(pedidosValidos, o => o.forma_pagamento_id > 1 ? o.reembolso_promocao : 0);
        indicadores.reembolso_novos = _.sumBy(pedidosValidos, o => o.primeiro || o.primeiro_estabelecimento ? o.reembolso_promocao : 0);

        indicadores.desconto_estabelecimento = _.sumBy(pedidosValidos, o => o.estabelecimento_cupom ? o.desconto : 0);

        const pedidosValidosPgtOnline = _.filter(pedidosValidos, o => o.forma_pagamento_id == -1);

        indicadores.quantidade_pgt_online = pedidosValidosPgtOnline.length
        indicadores.total_pgt_online = _.sumBy(pedidosValidosPgtOnline, calcValorBruto);

        const pedidosValidosPgtDinheiro = _.filter(pedidosValidos, o => o.forma_pagamento_id == 1);
        indicadores.quantidade_pgt_dinheiro = pedidosValidosPgtDinheiro.length;
        indicadores.total_pgt_dinheiro = _.sumBy(pedidosValidosPgtDinheiro, calcValorBruto);

        const pedidosValidosPgtMaquininha = _.filter(pedidosValidos, o => o.forma_pagamento_id > 1);
        indicadores.quantidade_pgt_maquininha = pedidosValidosPgtMaquininha.length;
        indicadores.total_pgt_maquininha = _.sumBy(pedidosValidosPgtMaquininha, calcValorBruto);

        const pedidosValidosNovos = _.filter(pedidosValidos, o => o.primeiro || o.primeiro_estabelecimento);

        indicadores.quantidade_novos = pedidosValidosNovos.length
        indicadores.total_novos = _.sumBy(pedidosValidosNovos, calcValorBruto);
        indicadores.total_taxa_servico_novos = _.sumBy(pedidosValidosNovos, o => o.taxa_servico);

        const pedidosValidosTaxaServico = _.filter(pedidosValidos, o => o.taxa_servico > 0);
        indicadores.quantidade_taxa_servico = pedidosValidosTaxaServico.length;
        indicadores.total_taxa_servico = _.sumBy(pedidosValidosTaxaServico, o => o.taxa_servico);

        indicadores.total_taxa_servico_pgt_online = _.sumBy(pedidosValidosTaxaServico, o => o.forma_pagamento_id == -1 ? o.taxa_servico : 0);
        indicadores.quantidade_taxa_servico_pgt_online = _.sumBy(pedidosValidosTaxaServico, o => o.forma_pagamento_id == -1 ? 1 : 0);
        indicadores.total_taxa_servico_pgt_dinheiro = _.sumBy(pedidosValidosTaxaServico, o => o.forma_pagamento_id == 1 ? o.taxa_servico : 0);
        indicadores.quantidade_taxa_servico_pgt_dinheiro = _.sumBy(pedidosValidosTaxaServico, o => o.forma_pagamento_id == 1 ? 1 : 0);
        indicadores.total_taxa_servico_pgt_maquininha = _.sumBy(pedidosValidosTaxaServico, o => o.forma_pagamento_id > 1 ? o.taxa_servico : 0);
        indicadores.quantidade_taxa_servico_pgt_maquininha = _.sumBy(pedidosValidosTaxaServico, o => o.forma_pagamento_id > 1 ? 1 : 0);

        const pedidosValidosTaxaEntrega = _.filter(pedidosValidos, o => o.taxa_entrega > 0);
        indicadores.quantidade_taxa_entrega = pedidosValidosTaxaEntrega.length;
        indicadores.total_taxa_entrega = _.sumBy(pedidosValidosTaxaEntrega, o => o.taxa_entrega);

        indicadores.total_liquido = _.sumBy(pedidosValidos, o => o.total);
        indicadores.total_liquido_pgt_online = _.sumBy(pedidosValidos, o => o.forma_pagamento_id == -1 ? o.total : 0);
        indicadores.total_liquido_pgt_dinheiro = _.sumBy(pedidosValidos, o => o.forma_pagamento_id == 1 ? o.total : 0);
        indicadores.total_liquido_pgt_maquininha = _.sumBy(pedidosValidos, o => o.forma_pagamento_id > 1 ? o.total : 0);

        indicadores.total_bruto_sem_taxa_servico = indicadores.total_bruto - indicadores.total_taxa_servico;
        indicadores.total_pgt_online_sem_taxa_servico = indicadores.total_pgt_online - indicadores.total_taxa_servico_pgt_online;
        indicadores.total_pgt_dinheiro_sem_taxa_servico = indicadores.total_pgt_dinheiro - indicadores.total_taxa_servico_pgt_dinheiro;
        indicadores.total_pgt_maquininha_sem_taxa_servico = indicadores.total_pgt_maquininha - indicadores.total_taxa_servico_pgt_maquininha;

        indicadores.total_liquido_sem_taxa_servico = indicadores.total_liquido - indicadores.total_taxa_servico;
        indicadores.total_liquido_pgt_online_sem_taxa_servico = indicadores.total_liquido_pgt_online - indicadores.total_taxa_servico_pgt_online;
        indicadores.total_liquido_pgt_dinheiro_sem_taxa_servico = indicadores.total_liquido_pgt_dinheiro - indicadores.total_taxa_servico_pgt_dinheiro;
        indicadores.total_liquido_pgt_maquininha_sem_taxa_servico = indicadores.total_liquido_pgt_maquininha - indicadores.total_taxa_servico_pgt_maquininha;

        indicadores.total_cancelados = _.sumBy(pedidosCancelados, calcValorBruto);
        indicadores.total_cancelados_nao_expirados = _.sumBy(pedidosCanceladosNaoExpirados, calcValorBruto);
        indicadores.total_cancelados_expirados = _.sumBy(pedidosCanceladosExpirados, calcValorBruto);

        indicadores.quantidade_taxa_servico_cancelados_nao_expirados = _.sumBy(pedidosCanceladosNaoExpirados, o => o.taxa_servico > 0 ? 1 : 0);
        indicadores.total_taxa_servico_cancelados_nao_expirados = _.sumBy(pedidosCanceladosNaoExpirados, o => o.taxa_servico);

        indicadores.quantidade_taxa_servico_cancelados_expirados = _.sumBy(pedidosCanceladosExpirados, o => o.taxa_servico > 0 ? 1 : 0);
        indicadores.total_taxa_servico_cancelados_expirados = _.sumBy(pedidosCanceladosExpirados, o => o.taxa_servico);

        indicadores.total_bruto_cancelados_nao_expirados_sem_taxa_servico = indicadores.total_cancelados_nao_expirados - indicadores.total_taxa_servico_cancelados_nao_expirados;
        indicadores.total_bruto_cancelados_expirados_sem_taxa_servico = indicadores.total_cancelados_expirados - indicadores.total_taxa_servico_cancelados_expirados;

        return indicadores;
      },
      async visualizarPedido(p) {
        try {
          this.loading = true;
          const pedido = await this.$root.getPedido(p.id);
          this.loading = false;
          this.pedido = pedido;
          this.dialog.visualizar = true;
        } catch (error) {
          let err = error.response && error.response.data ? error.response.data.error : "Ocorreu um erro ao carregar o pedido. Tente novamente!";
          window.getApp.$emit("APP_ALERT", { color: "red", text: err });
          this.loading = false;
        }
      },
      async alterarStatus(p) {
        try {
          this.loading = true;
          const pedido = await this.$root.getPedido(p.id);
          this.loading = false;
          this.pedido = pedido;
          this.dialog.alterarStatus = true;
        } catch (error) {
          let err = error.response && error.response.data ? error.response.data.error : "Ocorreu um erro ao alterar o status o pedido. Tente novamente!";
          window.getApp.$emit("APP_ALERT", { color: "red", text: err });
          this.loading = false;
        }
      },
      async printPedido(pedido) {
        try {
          await this.$root.printPedido(pedido);
          window.getApp.$emit("APP_DIALOG_AUX");
        } catch (error) {
          window.getApp.$emit('APP_ALERT', { color: 'orange darken-1', text: error.message });
        }
      },
      exportarCSV() {
        const data = [];
        if (!this.list.length) return;
        this.$firebase.logEvent('report_csv_exported', {
          order_count: this.list.length,
          establishment_id: this.estabelecimentoSelecionado ? this.estabelecimentoSelecionado.id : null,
        })

        this.list.map(pedido => {
          data.push({
            'PEDIDO': pedido.id,
            'ESTABELECIMENTO': pedido.estabelecimento_nome,
            'CIDADE': `${pedido.localidade_nome} - ${pedido.estado_nome}`,
            'STATUS': this.$root.$options.filters.statusPedido(pedido.status),
            'USUARIO': pedido.status == 3 ? '--' : pedido.usuario_nome,
            'PAGAMENTO': pedido.status == 3 ? '--' : pedido.forma_pagamento_id > -1 ? pedido.forma_pagamento_nome : 'Pagamento Online',
            'ENTREGA/RETIRADA': pedido.endereco_id == -1 ? 'Retirada' : 'Entrega',
            'INCENTIVOS': parseFloat((pedido.estabelecimento_cupom == 0 ? pedido.desconto : 0 )+pedido.reembolso_promocao).toFixed(2),
            'TAXA DE SERVIÇO': parseFloat(pedido.taxa_servico || 0).toFixed(2),
            'TAXA DE ENTREGA': parseFloat(pedido.taxa_entrega || 0).toFixed(2),
            'VALOR LÍQUIDO (C/ TAXA SERVIÇO)': parseFloat(pedido.total).toFixed(2),
            'VALOR BRUTO (C/ TAXA SERVIÇO)': parseFloat(pedido.total+(pedido.estabelecimento_cupom == 0 ? pedido.desconto : 0 )+pedido.reembolso_promocao).toFixed(2),
            'VALOR LÍQUIDO (S/ TAXA SERVIÇO)': parseFloat(pedido.total - (pedido.taxa_servico || 0)).toFixed(2),
            'VALOR BRUTO (S/ TAXA SERVIÇO)': parseFloat(pedido.total + (pedido.estabelecimento_cupom == 0 ? pedido.desconto : 0) + pedido.reembolso_promocao - (pedido.taxa_servico || 0)).toFixed(2),
            'DATA': this.$dayjs(pedido.data).format('DD/MM/YYYY HH:mm'),
            'ORIGEM': pedido.cardapio_digital ? 'Cardápio Digital' : 'Bigou Delivery'
          });
        });

        const options = {
          fieldSeparator: ";",
          quoteStrings: '"',
          decimalSeparator: ".",
          showLabels: true,
          showTitle: false,
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
          filename: `pedidos-bigou-${this.dataInicio}-${this.dataFim}`,
          headers: ["PEDIDO", "ESTABELECIMENTO", "CIDADE", "STATUS", "USUARIO", "PAGAMENTO", "ENTREGA/RETIRADA", "INCENTIVOS", "TAXA DE SERVIÇO", "TAXA DE ENTREGA", "VALOR LÍQUIDO (C/ TAXA SERVIÇO)", "VALOR BRUTO (C/ TAXA SERVIÇO)", "VALOR LÍQUIDO (S/ TAXA SERVIÇO)", "VALOR BRUTO (S/ TAXA SERVIÇO)", "DATA", "ORIGEM"],
        };

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(data);
      },
      validarDatas() {
        const dataInicio = this.$dayjs(this.dataRangeFormated.dataInicio, "YYYY-MM-DD", true);
        const dataFim = this.$dayjs(this.dataRangeFormated.dataFim, "YYYY-MM-DD", true);

        if (!dataInicio.isValid() || !dataFim.isValid()) {
          this.datasInvalidas = true;
          return;
        }

        const inicioDoMes = dataInicio.startOf("month");
        const fimDoMes = dataFim.endOf("month");

        // Verifica se as datas extrapolam o mês
        if (dataInicio.isBefore(inicioDoMes) || dataFim.isAfter(fimDoMes)) {
          this.datasInvalidas = true;
        } else {
          this.datasInvalidas = false;
        }
      },
    }
  };
  </script>

<style lang="scss">
  .inputDefault .v-input__control .v-input__slot{
    background-color: #f6f6f6!important;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, .15)!important;
  }

  .inputDefault.v-input.v-input--is-focused .v-input__control .v-input__slot{
    border: 1px solid #1d9a5a !important;
  }

</style>

<style lang="scss" scoped>
  .clicable {
    color:#0F7641;
    cursor:pointer;
  }
  .Poppins{
    font-family: "Poppins", "Roboto", "Helvetica";
  }
  .Captalize{
    text-transform: capitalize !important;
  }
  .conteudo {
    min-height: 100px;
    height: 100px;
  }
  .br-5{
      border-radius: 5px !important;
  }
  .br-10{
      border-radius: 10px !important;
  }
  .fw-7{
    font-weight: 700;
  }
  .botaoFiltro {
    color: #fff;
    height: 56px;
    width: 100%;
    font-size: 15px;
    font-weight: 700;
    text-transform: capitalize;
  }
  .botaoItemFiltro {
    color: #111312cc;
    background-color: #eaeaea !important;
    text-transform: capitalize;
  }
  .areaAddCategoria{
    justify-content: flex-start;
    display: flex;
    flex-flow:column wrap;
    align-content: stretch;
    align-items: stretch;
  }
  .botaoAdicionarCategoria {
    border-radius: 6px;
    color: #fff;
    min-height: 50px;
    font-size: 17px;
    font-weight: bold;
    text-transform: capitalize;
    float: left;
  }
  .cardPadrao{
    box-shadow:none !important;
    background-color: transparent;
  }
  .detalhesLista {
      background-color: #eaeaea7b;
      border-radius: 3px;
      box-shadow: 0 1px 1px #091e4240,0 0 1px #091e424f;
      display: block;
      margin-bottom: 8px;
      position: relative;
      scroll-margin: 8px;
      z-index: 0;
  }
  .botaoExportar {
    color: #111312cc;
    background-color: #E3F0E9 !important;
    text-transform: capitalize;
  }
  .tag-success{
    background-color: #1D9A5A;
  }
  .tag-warning{
    background-color: #E65300;
  }
  .tag-primary{
    background-color: #1D9A5A;
  }
  .tag-danger{
    background-color: #FF0F00;
  }
  .tag-normal{
    background-color: #007AFF;
  }
  .labelFiltro{
    margin: 10px;
    background-color: #E3F0E9;
    border-radius: 10px;
    max-width: 400px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
  }
  .panelPadrao{
    box-shadow: none!important;
    border-radius: 30px;
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.1)
  }
  .hidden {
    display: none;
    background-color: black;
  }
  .alertDatas{
    padding: 5px 10px;
    border: 1px solid #FF4B4B;
    display: flex;
    border-radius: 12px;
    align-content: center;
    justify-content: center;
    font-size: 14px;
    background-color: #ff4b4b2b;
    color: #fc00009e;
    text-align: center;
  }
</style>
